import base from './base'
import user from './user'
import group from './group'
import loan from './loan'
import device from './device'

export default Object.assign(
  {},
  base,
  user,
  group,
  loan,
  device
)



// WEBPACK FOOTER //
// ./src/api/api.js